@if (asCustomButton()) {
    <div (click)="drawer.open()">
        <ng-content></ng-content>
    </div>
} @else {
    <button mat-stroked-button class="ca-button" (click)="drawer.open()">
        {{ buttonText() | translate }}
    </button>
}

<ca-drawer
    #drawer
    (visibleChange)="onDrawerVisibleChange()"
    [bodyBordered]="productsService.products().length > 0 && !productsService.loading()"
>
    <h2 drawer-header class="ca-headline-2 ca-bold m-0">{{ headerText() | translate }}</h2>
    @if (drawer?.visible()) {
        <ca-product-filters
            drawer-top
            class="ca-product-filters"
            [allowedProductTypes]="allowedProductTypes()"
            [productName]="productName()"
            [productType]="productType()"
            (filter)="onFilter($event)"
        ></ca-product-filters>
    }
    @if (productsService.loading()) {
        <div drawer-body class="flex flex-auto justify-center items-center">
            <ca-spinner
                data-testid="loading-devices-spinner"
                [diameter]="48"
                [text]="'PRODUCT_PICKER.LOADING' | translate"
                [subtext]="'PRODUCT_PICKER.LOADING_DESCRIPTION' | translate"
            ></ca-spinner>
        </div>
    } @else if (productsService.error()) {
        <div drawer-body class="flex flex-col gap-2 flex-auto justify-center items-center">
            <div class="ca-headline-3">{{ 'PRODUCT_PICKER.ERROR' | translate }}</div>
            <div class="ca-text-lg">{{ 'PRODUCT_PICKER.ERROR_DESCRIPTION' | translate }}</div>
            <div>
                <button mat-button class="ca-button ca-button-m" (click)="productsService.readProducts()">
                    <ca-icon icon="update" class="ca-icon-s-16-p-0-f-16"></ca-icon>
                    <span class="underline">{{ 'CA.BUTTON.TRY_AGAIN' | translate }}</span>
                </button>
            </div>
        </div>
    } @else if (productsService.products().length === 0) {
        <div drawer-body class="flex flex-col gap-2 flex-auto justify-center items-center">
            <div class="ca-headline-3">{{ 'PRODUCT_PICKER.NO_PRODUCTS_FOUND' | translate }}</div>
            <div class="ca-text-lg">{{ 'PRODUCT_PICKER.NO_PRODUCTS_FOUND_DESCRIPTION' | translate }}</div>
        </div>
    } @else {
        <div drawer-body class="flex flex-col gap-4 flex-auto justify-between">
            <div class="flex flex-col gap-4 flex-auto">
                @for (product of productsService.products(); track product.id) {
                    <ca-product-tile
                        [product]="product"
                        [countryCode]="countryCode()"
                        [languageCode]="languageCode()"
                        [allowedProductTypes]="allowedProductTypes()"
                        [allowDifferentProductTypeSelection]="allowDifferentProductTypeSelection()"
                        [isSelected]="selectedProducts.includes(product)"
                        (selectProduct)="onProductSelect($event)"
                    ></ca-product-tile>
                }
            </div>
            @if (productsService.totalPages() > 1) {
                <div class="flex gap-4 justify-center items-center">
                    <button
                        mat-icon-button
                        class="ca-button ca-button-m"
                        (click)="productsService.firstPage()"
                        [disabled]="productsService.isFirstPage()"
                    >
                        <ca-icon icon="left-to-line" class="ca-icon-s-16-p-0-f-16"></ca-icon>
                    </button>
                    <button
                        mat-icon-button
                        class="ca-button ca-button-m"
                        (click)="productsService.previousPage()"
                        [disabled]="!productsService.hasPreviousPage()"
                    >
                        <ca-icon icon="chevron-left" class="ca-icon-s-16-p-0-f-16"></ca-icon>
                    </button>
                    <div>
                        <span>{{ productsService.pageIndex() + 1 }} / {{ productsService.totalPages() }}</span>
                    </div>
                    <button
                        mat-icon-button
                        class="ca-button ca-button-m"
                        (click)="productsService.nextPage()"
                        [disabled]="!productsService.hasNextPage()"
                    >
                        <ca-icon icon="chevron-right" class="ca-icon-s-16-p-0-f-16"></ca-icon>
                    </button>
                    <button
                        mat-icon-button
                        class="ca-button ca-button-m"
                        (click)="productsService.lastPage()"
                        [disabled]="productsService.isLastPage()"
                    >
                        <ca-icon icon="right-to-line" class="ca-icon-s-16-p-0-f-16"></ca-icon>
                    </button>
                </div>
            }
        </div>
    }
    <button drawer-footer mat-stroked-button class="ca-button ca-button-m" (click)="drawer.close()">
        <span>{{ 'CA.BUTTON.CANCEL' | translate }}</span>
    </button>
    <button drawer-footer mat-flat-button class="ca-button ca-button-m" [disabled]="!selectedProducts.length" (click)="confirm()">
        <span>{{ 'CA.BUTTON.CONFIRM' | translate }}</span>
    </button>
</ca-drawer>
